import {} from "@/api/user.js";
import { getCookie } from "@/utils/cookie";
import { checkModbile, validateEmail } from '@/utils/utils'

import { getAgent, createAgent, updateAgent, defaultData, meallist, purchasecode, aliCallBack, getUserInfo, activationMeal, mealActivationState, BDpromotionbrowse } from "@/api/user.js";
import axios from 'axios'
import draggable from 'vuedraggable';
import axiosFlow from '@/utils/axios-flow.js';
import axiosBoss from '@/utils/axios-boss.js';
import axiosBaidu from '@/utils/axios-baidu.js';

import animationContainer from "@/components/animationContainer";
import startNow from "@/components/startNow";
import serviceIndustry from "@/components/serviceIndustry";
import price from "./price.vue";
import { domainName } from '@/utils/domainName'

export default {
    name: 'home2page',
    components: {
        draggable,
        animationContainer,
        startNow,
        serviceIndustry,
        price
    },
    computed: {},
    watch: {},
    data() {
        return {
            loading: false,
            problemIndex: 0,
            tabPosition: 'left',
            navigationItems: [
                { id: '0', title: '一句话，搞定400+函数', content: 'ChatExcel可以替代函数处理，为用户提供更智能的数据处理服务。' },
                { id: '1', title: '数据可视化，多种图表展现', content: '数据可视化，近10种图表展现，折线图、柱状图、条形图、饼图、面积图等。' },
                { id: '2', title: '智能辅助，高性能数据分析', content: 'ChatExcel可进行多表分析、交叉对比等多种分析，能提供数据感知建议，自动纠错。' },
                // { id: '3', title: 'Free IO', content: '无需记函数、无需手动设置公式，只要在表格下的对话框内以文字输入要求，ChatExcel就能完成自运行，并可一键导出Excel表格。' },

                // 更多链接...
            ],
            sections: [
                { id: '0', title: 'Section 1 Title', img_url: 'answer1' },
                { id: '1', title: 'Section 2 Title', img_url: 'answer2' },
                { id: '2', title: 'Section 3 Title', img_url: 'answer3' },
                // { id: '3', title: 'Section 4 Title', img_url: 'answer4' },
                // 更多段落...
            ],
            activeTab: '0',
            currentIndex: 0,

            priceList: [{
                    id: 1,
                    title: '免费用户',
                    price: '0',
                    priceold: '',
                    btmlist: ['10次/月 AI会话额度', '仅限个人学习使用']
                },
                {
                    id: 2,
                    title: '单月套餐 VIP',
                    price: '9.9',
                    priceold: '原价 ¥29/月',
                    btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                },
                {
                    id: 3,
                    title: '一年套餐 VIP',
                    price: '99',
                    priceold: '原价 ¥348/年',
                    btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                },
                {
                    id: 4,
                    title: '半年套餐 VIP',
                    price: '59',
                    priceold: '原价 ¥174/年',
                    btmlist: ['每天50次 AI会话次数', 'VIP专属客服/发票']
                }
            ],
            commentList: [{
                    avatar: 'avatar1',
                    name: "职场老鸟",
                    comment: "酷表ChatExcel让人眼前一亮，简直是职场人的福音啊，省时省力省心～",
                },
                {
                    avatar: 'avatar2',
                    name: "行政宫先生",
                    comment: "你们开发ChatExcel这个网站，非常的酷，以自然语言描述需求，机器进行表格操作，非常适合我们整个行业需求。",
                },
                {
                    avatar: 'avatar3',
                    name: "互联网公司经理",
                    comment: "想说只有四个字，感谢你们。感谢你们辛苦的付出，为我们仍在一线手动操作表格的打工人而努力，期待早日解放。",
                },
                {
                    avatar: 'avatar4',
                    name: "北京某知名中学王老师",
                    comment: "酷表ChatExcel ，你输入一个句子，它就会自动运行，给我想要的结果，对于日常工作中的表格，处理起来更是效果惊人实在是太棒了！",
                },
                {
                    avatar: 'avatar5',
                    name: "市场负责人",
                    comment: "工具的价值就是提高效率，提升体验，酷表ChatExcel大大降低了使用Excel的门槛，让我们这些不擅长Excel的人也可能快速准确的进行数据处理。",
                },
                {
                    avatar: 'avatar6',
                    name: "小学教师",
                    comment: "梳理各种成绩的表格都可以在无需函数的情况下进行简单运算和数据整理。学生多，考试多，但是老师的法宝也不少～",
                },
                {
                    avatar: 'avatar7',
                    name: "客服代表",
                    comment: "新手用起来零难度，对于客服而言，对话形式处理表格更加便捷啦。",
                },
                {
                    avatar: 'avatar8',
                    name: "人力资源专员",
                    comment: "刚入职没多久，因为欠缺excel的技巧，在整理员工信息的表格中很吃力。但是用chatexcel不需要技术背景也可以高效整合信息。",
                },
                {
                    avatar: 'avatar9',
                    name: "数据录入员",
                    comment: "ChatExcel可以同时删减批量单元格内容，这种自动化功能大大减少了我的工作量，早点下班！",
                },
                {
                    avatar: 'avatar10',
                    name: "大学生",
                    comment: "特种兵式的旅游规划和预算管理用简单几句话就能实现，不愧是我的特种兵搭子！而且重点是免费免费免费！这羊毛薅得真香。",
                },
                {
                    avatar: 'avatar11',
                    name: "口腔医疗管理员",
                    comment: "原来都是用 command+F 来查找特定患者信息，一个一个点进去删改，用chatexcel一句话全能帮我改完～",
                },
            ],
            firstdata: [],
            seconddata: [],
            dialogVisible: false,
            mealList: [],
            getindex: 0,
            getitem: [],
            geturl: '',
            access_token: '',
            language: this.$store.state.language, //多语言

            tabList: [{
                    id: 1,
                    name: '自动处理Excel',
                    icon: 'tab_icon1',
                    content: 'ChatExcel可即时修改Excel文件，实现多表合并、工作表拆分、数据清洗和高级查询等功能，处理速度最高提升90%。该工具支持CSV、XLS和XLSX格式，可批量上传文件及处理多工作表工作簿。'
                },
                {
                    id: 2,
                    name: '智能数据分析',
                    icon: 'tab_icon2',
                    content: '轻松完成从基础求和、平均值计算到复杂公式运算的所有操作，在确保计算精度的同时，提供卓越的运算效率。'
                },
                {
                    id: 3,
                    name: '数据可视化图表',
                    icon: 'tab_icon3',
                    content: '对比实际业绩与预测数据时使用折线图，呈现当前状态时选择柱状图。我们提供适应多样化业务场景和需求的可视化解决方案。'
                },
                {
                    id: 4,
                    name: '文档秒变Excel',
                    icon: 'tab_icon4',
                    content: '一键实现PDF、图片等文件到Excel的轻松转换，智能文件转换功能可自动处理格式调整。'
                },
                {
                    id: 5,
                    name: '数据洞察分析',
                    icon: 'tab_icon5',
                    content: '通过AI驱动分析发现隐藏规律与趋势，无需专业统计知识即可生成可执行报告和预测性洞察。'
                },
                {
                    id: 6,
                    name: '零代码构建数据大盘',
                    icon: 'tab_icon6',
                    content: '自然语言生成数据大盘，支持拖拽操作实现自由布局，实时同步业务指标'
                },

            ],
            tabindex: 0,
            dialogNewMsg: false,
            items: [{
                img: 'new_msg_max',
                title: '能处理多文件、多sheet、大文件的Max上线',
                content: 'ChatExcel-Max支持100个工作簿同时处理，大文件、多文件、大体量数据的复杂处理和数据分析，也能一把搞定！👍'
            }, {
                img: 'new_msg_chart',
                title: '数据图表功能上线',
                content: '上传数据表就能自由生成各类精美图表，数据联动实时更新！拖拽调参轻松搞定，80+种图表唾手可得✨'
            }, ],
            currentIndex: 0,
            moreList: [{
                    img: 'more_1',
                    title: '多种文件类型',
                    content: '只需拖拽，就可以上传处理。多种输入格式（csv，xls，xlsx），多张Excel表格上传，且每张Excel表可以多Sheet，可以对Excel表进行任意处理。'
                },
                {
                    img: 'more_2',
                    title: '多种数据分析方式',
                    content: '作为你的专属AI Excel数据分析专家，轻松搞定多种分析方式，' + '<span style="color:#000;font-weight:500">对比分析、统计分析、交叉分析、相关分析</span>、' + '等多种分析，并可一键导出专业分析报告'
                }, {
                    img: 'more_3',
                    title: '多种图表形式',
                    content: ' 轻松创建图表，将数据转化为酷炫图表，' + '<span style="color:#000;font-weight:500">支持100多种图表类型，</span>' + '如柱状图、折线图、散点图和饼图等。只需10秒，就会获得专属报告。'
                }
            ],
            versionList: [{
                    img: 'version_1',
                    tit: 'SaaS企业版',
                    cont: '支持SSO，文件安全对接模式'
                },
                {
                    img: 'version_2',
                    tit: 'AI PC版本—支持联想、惠普、华为',
                    cont: 'AI PC安装适配，一键使用，本地模型运行数据安全'
                }, {
                    img: 'version_3',
                    tit: '一体机版本',
                    cont: '支持不同显卡一体机集成，模型本地运行，数据更安全'
                }, {
                    img: 'version_4',
                    tit: '企业本地部署私有化版本',
                    cont: '支持4卡使用集成，多人并发，集群部署'
                }, {
                    img: 'version_5',
                    tit: '支持MCP API调用使用',
                    cont: 'MCP 接口调用'
                }
            ],
            industryList: [{
                    img: 'industry_1',
                    tag: '财务行业',
                    color: '#F09340',
                    bg_color: '#fcefdb',
                    tit: '计算销售2部超过5000的销售额的总和'
                },
                {
                    img: 'industry_2',
                    tag: '人力资源',
                    color: '#4050F0',
                    bg_color: '#d9dcfa',
                    tit: '分析各部门的工资占比，并绘制圆环图'
                }, {
                    img: 'industry_3',
                    tag: '电商',
                    color: '#F06640',
                    bg_color: '#fcd8ce',
                    tit: '“时间”列为横坐标，“分层1”列，“分层2”列为纵坐标，绘制折线图'
                }, {
                    img: 'industry_4',
                    tag: '教育培训',
                    color: '#329C78',
                    bg_color: '#bddfd3',
                    tit: '提取年纪第1名、第20名、第60名和第80名的同学成绩，绘制成堆叠面积图'
                }, {
                    img: 'industry_5',
                    tag: '政企',
                    color: '#4F70E5',
                    bg_color: '#d8def9',
                    tit: '绘制折线图与堆叠柱状图的组合图。GDP为“堆积柱形图”，2023增率为“折线图”'
                }, {
                    img: 'industry_6',
                    tag: '制造业',
                    color: '#595959',
                    bg_color: '#e8e8e8',
                    tit: '绘制日历热力图：X轴：当前周数（【交货日期】按周分组），Y轴：【所属销售团队】'
                }
            ],
            personList: [{
                    img: 'img_1',
                    title: '互联网公司经理',
                    content: '新入职一家公司，用ChatExcel做了各式数据清晰的表格，效率高，老板非常满意，转正稳了。'
                },
                {
                    img: 'img_4',
                    title: '销售VP',
                    content: "第一次看同事用ChatExcel做销售报告时，惊呆了～～随口说句“按产品线生成动态热力图”，数据立刻变成会动的彩色地图！上周我处理用户调研，试着喊“把满意度和复购率做成双Y轴图，按年龄分组。”10秒就出了专业图表，还能自动标出异常值。现在全部门都在玩语言做表：“用旭日图分析渠道“”把增长超20%的标金色”。连财务老张看了都真香了，天天对着电脑喊：“应收账款做成跑马灯效果！”这工具最神的是 —— 你说人话，它出专业表，Excel小白秒变数据分析师！"
                },
                {
                    img: 'img_2',
                    title: '人力资源总监',
                    content: '一直在找一个好用的AI表格工具，操作简单，直接明了，还能处理数据校验，给出准确的校验结果，找到ChatExcel，一切问题都解决了，太棒了！'
                },
                {
                    img: 'img_5',
                    title: '财务总监',
                    content: '准确度没话说，用了下，只能说“真香！”，效率翻倍，效果也好'
                },
                {
                    img: 'img_6',
                    title: '客服代表',
                    content: '绝对的效率神器，太牛了！'
                },
                {
                    img: 'img_3',
                    title: '市场负责人',
                    content: '之前参加数据分析培训时，第一次接触到chatexcel这个神器，当老师演示用“生成分省GDP玫瑰图”指令秒出动态图表时，大家瞬间瞪大了眼睛，课后我试着上传员工行为能力测评表，用分组气泡图分析能力关联性，原本需求半小时的图表竟10秒生成，气泡大小还能智能匹配平均分，最惊喜的是组合图功能，把堆叠柱状图和增长率折线图完美融合，领导看到直夸专业！现在部门都在用ChatExcel做月报，效率提升不止十倍，真心感谢这个改变工作方式的AI神器！'
                },
                {
                    img: 'img_7',
                    title: '中小企业主',
                    content: '无意间刷到你们家的产品，上周使用了，大神奇了，感觉开启了新世界，惊艳到我！'
                }
            ],
            dynamicsList: [{
                    img: 'dynamics_1',
                    content: '央视《赢在AI+》总决赛全国十强，智能办公赛道第一，ChatExcel太棒了！',
                    open_url: 'https://blog.chatexcel.com/2025/06/23/%e5%a4%ae%e8%a7%86%e3%80%8a%e8%b5%a2%e5%9c%a8ai%e3%80%8bchatexcel%e8%8e%b7%e5%be%97%e6%99%ba%e8%83%bd%e5%8a%9e%e5%85%ac%e7%ac%ac%e4%b8%80%e5%90%8d/'
                },
                {
                    img: 'dynamics_2',
                    content: '华为HDC大会重磅！ChatExcel作为首批鸿蒙智能体，重新定义AI办公！',
                    open_url: 'https://blog.chatexcel.com/2025/06/21/%e5%8d%8e%e4%b8%bahdc-%e5%a4%a7%e4%bc%9a%e9%87%8d%e7%a3%85%ef%bc%81chatexcel%e4%bd%9c%e4%b8%ba%e9%a6%96%e6%89%b9%e9%b8%bf%e8%92%99%e6%99%ba%e8%83%bd%e4%bd%93%ef%bc%8c%e9%87%8d%e6%96%b0%e5%ae%9a/'
                }, {
                    img: 'dynamics_3',
                    content: '惠普联合ChatExcel发布AIPC创新成果，开启智能办公新时代',
                    open_url: 'https://blog.chatexcel.com/2025/07/10/%e6%83%a0%e6%99%ae%e8%81%94%e5%90%88chatexcel%e5%8f%91%e5%b8%83ai-pc%e5%88%9b%e6%96%b0%e6%88%90%e6%9e%9c%ef%bc%8c%e5%bc%80%e5%90%af%e6%99%ba%e8%83%bd%e5%8a%9e%e5%85%ac%e6%96%b0%e6%97%b6%e4%bb%a3/'
                }, {
                    img: 'dynamics_4',
                    content: 'ChatExcel亮相阿里云AI势能大会，获官方AI案例推荐',
                    open_url: 'https://blog.chatexcel.com/2025/07/10/chatexcel%e4%ba%ae%e7%9b%b8%e9%98%bf%e9%87%8c%e4%ba%91%e9%a3%9e%e5%a4%a9%e5%8f%91%e5%b8%83%e6%97%b6%e5%88%bb%ef%bc%8c%e6%90%ba%e6%89%8b%e7%99%be%e7%82%bcmcp%e5%b9%b3%e5%8f%b0%e5%bc%80%e5%90%af/'
                }
            ]

        }
    },
    created() {

    },
    async mounted() {


        this.setInitialHeight();
        window.addEventListener('resize', this.setInitialHeight);
        // this.commentList=$t(`startPage.recommend_config.commentList`)
        this.firstdata = this.commentList.slice(0, this.commentList.length / 2 + 1)
        this.seconddata = this.commentList.slice(this.commentList.length / 2 + 1)
        this.access_token = getCookie("access_token")
            // 支付宝支付成功回调函数
        if (this.$route.query.method && this.$route.query.method == 'alipay.trade.page.pay.return') {
            this.aliPayCallBack()
        }
        if (this.$route.query.isLogin) {
            this.$store.commit("setLoginDisplay", true);
        }
        if (this.$route.query.login_token) {
            this.$store.commit("setloginToken", this.$route.query.login_token);
        }
        if (this.$route.query.access_token) {
            this.$store.commit("setToken", this.$route.query.access_token);
        }
        if (this.$route.query.bd_vid) {
            BDpromotionbrowse({ bd_vid: this.$route.query.bd_vid }).then((res) => {});
        }
        setTimeout(() => {
            if (getCookie("login_token") && getCookie("login_token") != 'null' && getCookie("login_token") != null) {
                getUserInfo({
                    access_token: getCookie("access_token"),
                }).then((res) => {
                    this.$store.commit("setMobile", res.data.data.mobile ? res.data.data.mobile : res.data.data.email);
                    this.$store.commit('setUserInfo', JSON.stringify(res.data.data))
                    this.loading = false
                });
                activationMeal({
                    access_token: getCookie("access_token"),
                    activation_id: this.$route.query.activation_id,
                }).then((res) => {
                    this.showMeg()
                });
            } else {
                this.loading = false
            }
        }, 100);
        // if (!localStorage.getItem('newmassageState')) {
        //     this.dialogNewMsg = true
        // }

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setInitialHeight);
    },
    methods: {
        openPage(url) {
            window.open(url)
        },
        // 领取消息提醒接口
        showMeg() {
            mealActivationState({
                access_token: getCookie("access_token"),
                activation_id: this.$route.query.activation_id,
            }).then((res) => {
                if (res.data.data.state) {
                    if (res.data.data.status == 1) {
                        this.$message({
                            showClose: true,
                            type: 'success',
                            message: res.data.data.msg,
                            center: true
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            type: 'error',
                            message: res.data.data.msg,
                            center: true
                        });
                    }

                }

            });
        },
        setInitialHeight() {
            // console.log(this.$refs.contentArea.style.height,window.innerHeight,111)
            // this.$refs.contentArea.style.height = `${window.innerHeight}px`;
            // this.$refs.contentArea.style.height = `${window.innerHeight}px`;
        },
        handleTabClick(tab, event) {
            console.log(tab.name)
            this.scrollToSection(tab.name);
        },

        handleMouseEnter(tabId) {
            this.hoveredTab = tabId;
            this.activeTab = tabId
                // if (this.activeTab !== tabId) {
                //     this.scrollToSection(tabId);
                // }
            this.goToSlide()
            this.$nextTick(() => this.$forceUpdate());

        },

        goToSlide() {
            // this.currentIndex = 3;
            const carousel = this.$refs.carouselRef;
            console.log(carousel)
            carousel.activeIndex = this.activeTab * 1
        },
        handleMouseLeave() {
            this.hoveredTab = null;
        },
        scrollToSection(sectionId) {
            const sectionElement = document.getElementById(sectionId);
            if (sectionElement) {
                sectionElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        },
        useBtn() {
            if (getCookie("access_token")) {
                if (!getCookie("login_token")) {
                    this.$store.commit("setLoginDisplay", true);
                    return
                }
                location.href = domainName.api8 + '/#/sheet'
            } else {
                this.$store.commit("setLoginDisplay", true);
            }
        },
        useBtnPro() {
            if (getCookie("access_token")) {
                if (!getCookie("login_token")) {
                    this.$store.commit("setLoginDisplay", true);
                    return
                }
                location.href = domainName.api9 + '/#/excelPro'
            } else {
                this.$store.commit("setLoginDisplay", true);
            }
        },
        handleClose(done) {
            // this.$confirm('确认关闭？')
            //   .then(_ => {
            //     done();
            //   })
            //   .catch(_ => {});
        },
        // 点击购买
        goBuy(index) {
            if (!getCookie("access_token")) {
                this.$store.commit("setLoginDisplay", true);
            } else {
                this.getExceltest()
                this.getindex = index
                this.dialogVisible = true
            }

        },
        // 选择购买时长
        clickType(item, index) {
            this.getindex = index
            this.getitem = item
            this.getqrCode()
        },
        // meallist, purchasecode 
        //   套餐列表
        getExceltest() {
            // ?r=v1/common/upload-image
            meallist({ meal_type: 'excel', access_token: getCookie("access_token"), }).then((res) => {
                this.mealList = res.data.data
                this.getitem = this.mealList[this.getindex]
                this.getqrCode()
                    // this.getitem = this.mealList[0]
                    // this.getqrCode()
            });
        },
        getqrCode() {
            purchasecode({ meal_type: 'excel', id: this.getitem.id, access_token: getCookie("access_token"), }).then((res) => {
                this.geturl = res.data.data.url
            });
        },
        buyClick() {
            location.href = this.geturl
                // window.open(this.geturl)
        },
        aliPayCallBack() {
            let params = this.$route.query
            params.access_token = getCookie("access_token")
            aliCallBack(params).then((res) => {});
        },
        handleChange(index) {
            this.currentIndex = index;
        },
        goTo(index) {
            console.log(65432)
            this.$refs.carousel.setActiveItem(index);
            this.currentIndex = index;
        },
        // 新功能提醒
        knowclick() {
            this.dialogNewMsg = false
            localStorage.setItem('newmassageState', true)
        },
        handleClose() {
            this.knowclick()
        },
        // 下载客户端
        clickDownload() {
            this.$router.push({
                name: 'downloadClient',
            })
        },
        showModule(index) {
            this.tabindex = index;
        },
        hideModule() {
            // this.tabindex = null;
        }
    }
}